import { Col, Button } from "react-bootstrap";
import { Link } from 'react-router';
import "./ProjectCard.css";

export const ProjectCard = ({ title, description, img, technologies = [] }) => {
    return (
        <Col xs={12} sm={6} md={6} lg={4}>
            <div className="proj-imgbox">
                <img src={img} alt={title} loading="lazy" />

                {technologies.length > 0 && (
                    <div className="proj-tech-icons">
                        {technologies.map((tech, index) => {
                            const IconComponent = tech.icon;
                            return (
                                <div
                                    key={index}
                                    className="tech-icon-circle"
                                    title={tech.name}
                                >
                                    <IconComponent color={tech.color || "default"} />
                                </div>
                            );
                        })}
                    </div>
                )}

                <div className="proj-txtx">
                    <h4>{title}</h4>
                    <span>{description}</span>
                    <br/><br/>
                    <Button
                        as={Link}
                        to={`/proyecto/${title}`}
                        onClick={() => sessionStorage.setItem('scrollTo', 'projects')}
                        variant="outline-light"
                    >
                        Ver detalles
                    </Button>
                </div>
            </div>
        </Col>
    );
};